export const CONFIGURED_FEATURES = {
  SSR: 'SSR',
  CCBAT: 'CCBAT',
  AUTO_APPLY_ACCESSORIAL: 'AUTO_APPLY_ACCESSORIAL',
};

export const FEATURE_FLAGS = {
  SSR: ENABLE_SSR,
  CCBAT: ENABLE_CCBAT,
  AUTO_APPLY_ACCESSORIAL: ENABLE_AUTO_APPLY_ACCESSORIAL,
};

export const featureEnabled = (feature) => {
  if (!(feature && CONFIGURED_FEATURES[feature])) {
    console.log(`[featureEnabled] Feature flag configuration is invalid. Feature - ${feature}`);
    return;
  }
  return FEATURE_FLAGS[feature] === true;
};
